import React from 'react';
import PropTypes from 'prop-types';

import {Button, Stack, TextCharLimit, Alert} from 'views/components';
import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Translate, translate} from 'views/module';

const EditShortId = (props) => {
  const [shortId, setShortId] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [showError, setShowError] = React.useState(false);

  const {
    shortId: parentShortId,
    caregiverBackend,
    isEditing,
    setIsEditing,
  } = props;

  React.useEffect(() => {
    setShortId(parentShortId);
  }, [parentShortId]);

  const onSave = () => {
    setLoading(true);
    const onSucess = () => {
      setLoading(false);
      setIsEditing(false);
    };
    const onError = (error) => {
      setLoading(false);
      setErrorMsg(
        error.message === 'short_id_taken' ?
        `${translate('caregiver.CaregiverDetail.Settings.ProfileUrl.EditDialog.ErrorMessageShortIdTaken')}` :
       `${translate('caregiver.CaregiverDetail.Settings.ProfileUrl.EditDialog.ErrorMessageDefault')}`,
      );
      setShowError(true);
    };
    caregiverBackend.detail.updateShortId(shortId, onSucess, onError);
  };

  const isValid = () => {
    return Boolean(shortId && shortId !== parentShortId);
  };

  const onClose = () => {
    setIsEditing(false);
  };

  return (
    <>
      <Dialog onClose={onClose} open={isEditing}>
        <DialogTitle onClose={onClose}>
          <Translate expression='caregiver.CaregiverDetail.Settings.ProfileUrl.EditDialog.Action' />
        </DialogTitle>
        <DialogContent>
          <Stack
            sx={{
              m: 1,
            }}
            spacing={1}
          >
            <TextCharLimit
              label={translate('caregiver.CaregiverDetail.Settings.ProfileUrl.EditDialog.NewShortId')}
              value={shortId}
              onChange={setShortId}
              charLimit={50}
              error={false}
            />
            {
              showError &&
              <Alert severity="error" onClose={() => setShowError(false)}>
                {errorMsg}
              </Alert>
            }
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={onClose}>
            <Translate expression='generic.Close' />
          </Button>
          <Button
            color="error"
            disabled={!isValid()}
            onClick={onSave}
            loading={loading}
          >
            <Translate expression='generic.Save' />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

EditShortId.propTypes = {
  shortId: PropTypes.string.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(EditShortId);
